import React, { useEffect } from 'react';
import { useState } from 'react';
import { toast } from 'react-toastify';
import { CRYPTO_SECRET_KEY, base_url } from '../utilities';
import axios from 'axios';
import { useNavigate } from 'react-router';
import CryptoJS from 'crypto-js'
import { encrypt } from '../utils';
import Cookies from 'js-cookie';

const BusinessLoginEmail = () => {

  const navigate = useNavigate();

  const [togglePassword, setTogglePassword] = useState(false)
  const [toggleConfirmPwd, setToggleConfirmPwd] = useState(false)
  const [error, setError] = useState('');
  const showPassword = () => { setTogglePassword(true) };
  const hidePassword = () => { setTogglePassword(false) };

  const showConfirmPassword = () => { setToggleConfirmPwd(true) }
  const hideConfirmPassword = () => { setToggleConfirmPwd(false) }

  const [enterPassword, setEnterPassword] = useState('')
  const [confirmPwd, setConfirmPwd] = useState('')
  const [onboardingToken] = useState(() => {
    const tokenFromUrl = new URLSearchParams(window.location.search).get('token');
    if (tokenFromUrl) {
      sessionStorage.setItem('business_onboarding_token', tokenFromUrl);
    }
    return tokenFromUrl || sessionStorage.getItem('business_onboarding_token') || '';
  })
  useEffect(() => {
    if(window.innerWidth  < 920){
      alert("Please access this from desktop");
    }
    if (!onboardingToken) {
      toast.error("Invalid or expired onboarding link");
      return;
    }
    const currentURL = window.location.href;
    // Remove the query parameter
    const updatedURL = currentURL.split('?')[0];
    // Replace the current URL with the updated URL
    window.history.replaceState({}, document.title, updatedURL);
  
    axios
      .post(base_url + "find/user", {
        onboarding_token: onboardingToken
      })
      .then((res) => {
        if (res.data.data[0].is_password_set === 1) {
          navigate("/");
        }
      })
      .catch(() => {
        toast.error("Invalid or expired onboarding link");
      })
      
  }, [navigate, onboardingToken]);

  const handleSaveButton = (e) => {
    e.preventDefault()
    if (enterPassword.length < 6) {
      toast.error("Password must have atleast 6 characters", {
        toastId: 103
      })
    } else {
      let hashedpassword = CryptoJS.AES.encrypt(enterPassword, CRYPTO_SECRET_KEY).toString();
      axios
        .post(base_url + "password/update/initial/onborading", {
          onboarding_token: onboardingToken,
          password: hashedpassword
        })
        .then((res) => {
          if (res.data.status === 200) {
            sessionStorage.removeItem('business_onboarding_token')
            const { access_token, auth_refresh_token } = res.data
            toast.success("Successfully saved the password", {
              toastId: 103
            })
            setTimeout(() => {
              // window.location.reload()
            });
            //admin session removing
            Cookies.remove("User_Accesstoken_Admin");
            Cookies.remove("User_Refreshtoken_Admin");
            // investor session removing
            Cookies.remove("User_Accesstoken_Investor");
            Cookies.remove("User_Refreshtoken_Investor");
            //creating the business session below
            Cookies.set("user_name", res.data.data[0].user_name, { expires: 7 });
            Cookies.set("user_id", res.data.data[0].user_id, { expires: 7 });
            Cookies.set('User_Accesstoken', access_token, { expires: 7 })
            // Cookies.set('role_code', res.data.data[0].role_code)
            const encryptrole_code = encrypt(res.data.data[0].role_code);
            Cookies.set("role_code", encryptrole_code, { expires: 7 });
            Cookies.set('User_Refreshtoken_Business', auth_refresh_token, { expires: 7 })
            Cookies.set('User_Accesstoken_Business', access_token, { expires: 7 })
            userSession()
            Cookies.set("kyc_status", 0, { expires: 7 })
            navigate('/kycform');
          }
          else {
            toast.error(res.data.message, {
              toastId: 104
            })
          }
        })
        .catch(() => {
          // The shared interceptor displays invalid/expired onboarding errors.
        })


    }
  }
  const userSession = () => {
    setInterval(() => {
      axios.post(base_url + "user/refreshtoken", {
        "auth_refresh_token": Cookies.get('User_Refreshtoken_Business')
      })
        .then(res => {
          Cookies.set('User_Accesstoken_Business', res.data?.access_token, { expires: 7 })
        })
        .catch(err => {
          console.log(err);
        })
    }, 50 * 60 * 1000);
  }
  const [isPasswordValid, setIsPasswordValid] = useState(false);
  const handleChangePassword = (e) => {
    let value = e.target.value;
    let name = e.target.name;

    if (name === "password") {
      if (value !== '' || value !== undefined) {
        const regex = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*()_+~\-={}\[\]|\\:;"'<>,.?/]).{8,}$/;
        if (regex.test(value)) {
          setEnterPassword(value)
          setError(""); 
          setIsPasswordValid(true); 
        }else {
          setError("Password does not meet the criteria.");
          setIsPasswordValid(false);
        }
      }
    }
    if (name === "confirmpassword") {
      if (value !== '' || value !== undefined) { setConfirmPwd(value) }
      if (enterPassword && value !== enterPassword) {
        setError("Passwords do not match.");
      } else {
        setError(""); // Clear error if passwords match
      }
    }
  }


  return (
    <div className='loginTruemail justify-content-center d-flex'>
      <div className='emailmaindiv'>
        <article className='emaillogintxtdstyl'><span class="blue_txt ">Congratulations!</span> You have successfully registered.
          Take the benefits of Bennefin and grow in your business</article>

        <div className="d-flex  align-items-center">

          <div className=''>
            <h4 className="mb-3 d-flex justify-content-center ">
              <img className="img-fluid " style={{ height: "80px" }} src="./images/blue_brand_name.svg" alt="true" />
            </h4>

            <form className='gap-3 d-flex flex-column'>
              <div class="position-relative">
                <div className="form-group admin_login_label_email">
                  <label htmlFor="password">Enter New Password<span className="text-danger"> *</span></label>
                  <input
                    id="password"
                    name="password"
                    type={togglePassword ? "text" : "password"}
                    className="form-control rounded px-4 py-3 border-0"
                    onChange={handleChangePassword}

                  />

                </div>
                <img src="./images/password_eye.svg" className='show_password_eye' alt="" onMouseDown={showPassword} onMouseUp={hidePassword} />

              </div>
              <div class="position-relative mt-2">
                <div className="form-group admin_login_label_email ">
                  <label htmlFor="confirmpassword">Re-confirm Password<span className="text-danger"> *</span></label>
                  <input
                    name="confirmpassword"
                    id="confirmpassword"
                    type={toggleConfirmPwd ? "text" : "password"}
                    className="form-control rounded px-4 py-3 border-0"
                    onChange={handleChangePassword}
                    disabled={!isPasswordValid} 
                  />
                  <div className="d-flex justify-content-between">
                  </div>
                </div>

                <img src="./images/password_eye.svg" className='show_password_eye' alt="" onMouseDown={showConfirmPassword} onMouseUp={hideConfirmPassword} />
              </div>

              {error && <span className="text-danger " >{error}</span>}
              <div className="d-grid"  >
                <button onClick={handleSaveButton} style={{ width: " 426px", height: "50px" }} className="btn blue_btn fw-bolder mt-5" disabled={enterPassword !== '' && enterPassword === confirmPwd ? false : true} >
                  <span className='emailloginSave' >Save</span>
                </button>
              </div>
            </form>
          </div>


        </div>
       
      </div>
      <div className='password_msg '>
        <span class="passwd_criteria">The password should meet the following criteria:</span>
        <ul>
          <li>It should be at least 8 characters long</li>
          <li>It should contain at least 1 number.</li>
          <li>It should contain at least 1 uppercase character.</li>
          <li>It should contain at least 1 lowercase character.</li>
          <li>It should contain at least 1 symbol.</li>
        </ul>

      </div>
    </div>
  );
}
export default BusinessLoginEmail;
